import { THEME } from 'gcs-common/constants/themes';
import { getThemeIdentifier } from 'gcs-common/slices/theme/themeSelectors';
import { useSelector } from 'react-redux';
import LoginClassic from './LoginClassic/LoginClassic';
import LoginWithSideMenu from './LoginWithSideMenu/LoginWithSideMenu';

const Landing = () => {
  const theme = useSelector(getThemeIdentifier);

  if (theme === THEME.AGENT) {
    return <LoginClassic />;
  }

  return <LoginWithSideMenu />;
};

export default Landing;
